import update from 'immutability-helper';
import React, { createContext, useContext, useReducer } from 'react';
import usePage from '@dashboard/hooks/usePage';

const FeesContext = createContext();

const findIndex = (state, fee) =>
  state.findIndex(item => (fee._id ? item._id === fee._id : item.key === fee.key));

function feesReducer(state, action) {
  switch (action.type) {
    case 'add':
      if (state && state.length > 0) {
        const newIndex = action.index || state.length;

        return update(state, {
          $apply: currentState => currentState.map(fee => ({ ...fee, isEditing: false })),
          $splice: [[newIndex, 0, ...action.values]],
        });
      } else {
        return action.values;
      }
    case 'set':
      return update(state, { $set: action.values });
    case 'update':
      return update(state, { [findIndex(state, action.fee)]: { $set: action.values } });
    case 'delete':
      return state.filter((_, index) => index !== findIndex(state, action.fee));
    default:
      return state;
  }
}

export const FeesProvider = ({ children }) => {
  const { page } = usePage();

  const [state, dispatch] = useReducer(feesReducer, page?.fees || []);

  return <FeesContext.Provider value={{ state, dispatch }}>{children}</FeesContext.Provider>;
};

export const useFees = () => useContext(FeesContext);
